'use client';

import { EyeIcon } from '@/components/icons';
import { ChangeEvent, useState } from 'react';

interface IInputProps {
  name: string;
  className?: string;
  value: string;
  handleChange: (e: ChangeEvent<HTMLInputElement>, index?: number) => void;
  handleClick?: () => void;
  onBlur?: () => void;
  placeholder?: string;
  isInvalid?: boolean;
  type?: string;
}

export const InputPassword = ({
  name,
  className = '',
  placeholder = 'Type here...',
  value,
  handleChange,
  handleClick = () => {},
  onBlur = () => {},
  isInvalid = false,
}: IInputProps) => {
  const [type, setType] = useState<'password' | 'text'>('password');
  const toggleType = () => setType((prevType) => (prevType === 'password' ? 'text' : 'password'));

  return (
    <div className='relative'>
    <input
      type={type}
      name={name}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      className={`${className} text-gray-400 bg-gray-800 w-full px-4 py-[10px] rounded ${isInvalid ? 'outline outline-1 outline-error-700' : ''}`}
      onClick={handleClick}
      onBlur={onBlur}
    />
    <button className='absolute h-full aspect-square grid place-items-center right-0 top-0' onClick={toggleType} type="button" tabIndex={2}><EyeIcon /></button>
    </div>
  );
};
